import {
  Button,
  Checkbox,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { addProductSchema } from "dashboard/schemas";
import { Field, Form, Formik } from "formik";
import React, { useEffect } from "react";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import { ImageInput } from "components";
import { uploadFile } from "utils";
import { Cancel } from "@mui/icons-material";
import { database, storage } from "configs/firebaseConfigs";
import { deleteObject, ref as storageRef } from "firebase/storage";
import { useSuppliers } from "hooks/useDataFetch";
import Swal from "sweetalert2";
import { db, useIsMounted } from "hooks";
import { useParams } from "react-router-dom";
import { onValue, ref } from "firebase/database";

const EditProduct = () => {
  const [images, setImages] = React.useState([]);
  const [initialValues, setInitialValues] = React.useState({
    description: "",
    discount: "",
    images: [],
    name: "",
    price: "",
    quantity: "",
    shortDesc: "",
    supplierId: "",
    supplierName: "",
    title: "",
    waterQuantity: "",
    orderType: "",
    featured: false,
  });

  const isMounted = useIsMounted();
  const suppliers = useSuppliers();

  const { id } = useParams();

  // console.log(id);

  useEffect(() => {
    if (isMounted.current) {
      if (!id) return;
      onValue(ref(database, `/products/${id}`), (snap) => {
        if (snap.exists()) {
          const data = snap.val();
          console.log(data);
          setInitialValues({
            description: data?.description,
            discount: data?.discount,
            images: data?.images,
            name: data?.name,
            price: data?.price,
            quantity: data?.quantity,
            shortDesc: data?.shortDesc,
            supplierId: data?.supplierId,
            supplierName: data?.supplierName,
            title: data?.title,
            waterQuantity: data?.waterQuantity,
            orderType: data?.orderType,
            featured: data?.featured,
          });
          setImages(data?.images);
        }
      });
    }
  }, [id, isMounted]);

  const validationSchema = addProductSchema.reduce(
    (accumulator, currentValue) => {
      accumulator[currentValue.name] = currentValue.validationSchema;
      return accumulator;
    },
    {}
  );

  const handleSubmit = async (values, submitProps) => {
    try {
      console.log(values);
      await db.updateDb(`products/${id}`, values);

      Swal.fire({
        title: "Success",
        text: "Product updated successfully",
        icon: "success",
      });
      submitProps.resetForm();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  const deleteFile = async (path) => {
    // console.log(path);
    try {
      const filePath = storageRef(storage, path);
      await deleteObject(filePath);
      setImages(images.filter((image) => image.path !== path));
      console.log("deleted successfully ");
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = async (e) => {
    const path = `products/${Date.now()}`;

    const file = e.target.files[0];

    if (!file) {
      return;
    }

    const downLoadUrl = await uploadFile({ path, file });

    setImages((prev) => {
      return [
        ...prev,
        {
          path,
          url: downLoadUrl,
          createdAt: Date.now(),
        },
      ];
    });
  };

  // console.log(images);

  return (
    <div className="dashboard-product-container">
      <div className="product-add-title">Update Product</div>
      <div className="w-100">
        <Formik
          enableReinitialize
          initialValues={{
            ...initialValues,
          }}
          validationSchema={Yup.object(validationSchema)}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form className="auth-form-field">
              <Grid container spacing={2} justifyContent="start">
                {addProductSchema?.map((inputItem) => (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={
                      inputItem?.name === "shortDesc" ||
                      inputItem?.name === "description" ||
                      inputItem?.name === "images"
                        ? 12
                        : 6
                    }
                    key={inputItem.name}
                  >
                    <Field name={inputItem.name} key={inputItem.key}>
                      {(props) => (
                        <>
                          {inputItem.name === "shortDesc" ? (
                            <div className="flex-column  auth-input-form ">
                              <InputLabel> {inputItem?.label} </InputLabel>
                              <ReactQuill
                                value={formik.values.shortDesc}
                                onChange={(value) => {
                                  formik.setFieldValue("shortDesc", value);
                                }}
                                style={{
                                  height: "100px",
                                  marginBottom: "2rem",
                                }}
                              />
                              <h3 className="supplier-error">
                                {formik?.touched[inputItem.name] &&
                                  formik.errors[inputItem.name]}
                              </h3>
                            </div>
                          ) : inputItem.name === "images" ? (
                            <div className="flex-column  auth-input-form ">
                              <InputLabel> {inputItem?.label} </InputLabel>
                              <h3 className="supplier-error">
                                {formik?.touched[inputItem.name] &&
                                  formik.errors[inputItem.name]}
                              </h3>
                              <div className="product-image-input">
                                <ImageInput
                                  onChange={(e) => {
                                    handleChange(e);
                                    formik.setFieldValue("images", images);
                                  }}
                                />

                                {images?.length > 0 &&
                                  images?.map((item, index) => {
                                    return (
                                      <span
                                        className="preview-images flex-column "
                                        key={index}
                                      >
                                        <img src={item.url} alt="preview" />
                                        <span className="flex-row align-items-center delete-image-button">
                                          <Button
                                            onClick={() => {
                                              deleteFile(item.path);
                                            }}
                                            className=""
                                            endIcon={<Cancel />}
                                          >
                                            Cancel
                                          </Button>
                                        </span>
                                      </span>
                                    );
                                  })}
                              </div>
                            </div>
                          ) : inputItem?.name === "description" ? (
                            <div className="flex-column  auth-input-form ">
                              <InputLabel> {inputItem?.label} </InputLabel>
                              <ReactQuill
                                value={formik.values.description}
                                onChange={(value) => {
                                  formik.setFieldValue("description", value);
                                }}
                                style={{
                                  height: "300px",
                                  marginBottom: "2rem",
                                }}
                              />
                              <h3 className="supplier-error">
                                {formik?.touched[inputItem.name] &&
                                  formik.errors[inputItem.name]}
                              </h3>
                            </div>
                          ) : inputItem?.name === "supplierId" ? (
                            <div className="flex-column  auth-input-form ">
                              <InputLabel> {inputItem?.label} </InputLabel>
                              <Select
                                fullWidth
                                disabled
                                value={formik.values[inputItem.name]}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    inputItem.name,
                                    e?.target?.value
                                  );
                                }}
                                error={
                                  formik.errors[inputItem.name] &&
                                  formik.touched[inputItem.name]
                                }
                              >
                                <MenuItem value="">
                                  <em>Choose Supplier</em>
                                </MenuItem>
                                {suppliers?.data ? (
                                  suppliers?.data?.map((item) => {
                                    return (
                                      <MenuItem value={item.id} key={item.id}>
                                        {item?.name}
                                      </MenuItem>
                                    );
                                  })
                                ) : (
                                  <MenuItem value="">
                                    <em>No Supplier</em>
                                  </MenuItem>
                                )}
                              </Select>
                              <h3 className="supplier-error">
                                {formik?.touched[inputItem.name] &&
                                  formik.errors[inputItem.name]}
                              </h3>
                            </div>
                          ) : inputItem?.name === "orderType" ? (
                            <div className="flex-column  auth-input-form ">
                              <InputLabel> {inputItem?.label} </InputLabel>
                              <Select
                                fullWidth
                                value={formik.values[inputItem.name]}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    inputItem.name,
                                    e?.target?.value
                                  );
                                }}
                                error={
                                  formik.errors[inputItem.name] &&
                                  formik.touched[inputItem.name]
                                }
                              >
                                <MenuItem value="">
                                  <em>Choose Order Type</em>
                                </MenuItem>
                                <MenuItem value="individual">
                                  Individual
                                </MenuItem>
                                <MenuItem value="corporate">Corporate</MenuItem>
                              </Select>
                              <h3 className="supplier-error">
                                {formik?.touched[inputItem.name] &&
                                  formik.errors[inputItem.name]}
                              </h3>
                            </div>
                          ) : inputItem?.name === "featured" ? (
                            <div className="flex-row  auth-input-form w-100 ">
                              <InputLabel> {inputItem?.label} </InputLabel>
                              <Checkbox
                                checked={formik.values.featured}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "featured",
                                    !formik.values.featured
                                  );
                                }}
                              />
                            </div>
                          ) : (
                            <div className="flex-column  auth-input-form ">
                              <InputLabel> {inputItem?.label} </InputLabel>
                              <TextField
                                name={inputItem.name}
                                type={inputItem.type}
                                value={formik.values[inputItem.name]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.errors[inputItem.name] &&
                                  formik.touched[inputItem.name]
                                }
                                {...props}
                              />
                              <h3 className="supplier-error">
                                {formik?.touched[inputItem.name] &&
                                  formik.errors[inputItem.name]}
                              </h3>
                            </div>
                          )}
                        </>
                      )}
                    </Field>
                  </Grid>
                ))}
              </Grid>
              <div className="w-100 flex-row justify-content-center align-items-center">
                <Button type="submit" className="addProductButton">
                  Update Product
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default EditProduct;
